export default {
  "content": "<path d=\"M12.192 16.748c-1.668 0-2.88-.804-3.192-2.304l1.944-.36c.144.66.6 1.032 1.248 1.02.72-.012 1.284-.54 1.284-1.332s-.504-1.368-1.308-1.368c-.48 0-.852.204-1.056.516l-1.86-.228L9.648 8h5.172v1.716h-3.66l-.144 1.656c.348-.336.864-.552 1.5-.552 1.764 0 2.856 1.248 2.856 2.904 0 1.764-1.38 3.024-3.18 3.024z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.929 4.928c3.905-3.905 10.237-3.905 14.142 0 3.905 3.906 3.905 10.238 0 14.143-3.905 3.905-10.237 3.905-14.142 0-3.905-3.905-3.906-10.237 0-14.143zm12.728 1.415A8.001 8.001 0 106.343 17.659 8.001 8.001 0 0017.657 6.343z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};